import { makeStyles } from "@material-ui/core/styles";

const DRAWER_WIDTH = 256;
const HEADER_HEIGHT = 56;

const useSMQMainContainerStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    minHeight: "100vh",
    overflow: "hidden",
    backgroundColor: "#eef2f8",
    color: "#0f1a2e",
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    borderBottom: "1px solid #d7dfeb",
    backgroundColor: "#ffffff",
    color: "#0f1a2e",
    boxShadow: "0 4px 18px rgba(15, 26, 46, 0.08)",
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${DRAWER_WIDTH}px)`,
    marginLeft: DRAWER_WIDTH,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  toolbar: {
    minHeight: HEADER_HEIGHT,
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(1),
    "&.MuiToolbar-root": {
      minHeight: HEADER_HEIGHT,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  menuButtonHidden: {
    display: "none",
  },
  title: {
    overflow: "hidden",
    color: "#0f1a2e",
    fontFamily: "'DM Sans', sans-serif",
    fontSize: 18,
    fontWeight: 700,
    textOverflow: "ellipsis",
  },
  expand: {
    flexGrow: 1,
  },
  modeSwitcher: {
    marginRight: theme.spacing(2),
    "& .MuiButton-root": {
      borderRadius: 9,
      color: "#0f6672",
      fontFamily: "'DM Sans', sans-serif",
      fontWeight: 600,
      textTransform: "none",
      "&:hover": {
        backgroundColor: "#eef8fa",
      },
      "&:focus-visible": {
        outline: "2px solid #00a3b4",
        outlineOffset: 2,
      },
    },
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  drawerPaper: {
    position: "relative",
    width: DRAWER_WIDTH,
    height: "100vh",
    flexShrink: 0,
    overflowX: "hidden",
    borderRight: "1px solid #d7dfeb",
    backgroundColor: "#ffffff",
    color: "#5a6b8c",
    whiteSpace: "nowrap",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    "@media (max-width: 1024px)": {
      position: "fixed",
    },
  },
  drawerPaperClose: {
    width: 0,
    borderRight: 0,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    minHeight: HEADER_HEIGHT,
    padding: "0 8px 0 12px",
    backgroundColor: "#ffffff",
  },
  logo: {
    width: 156,
    height: 34,
    borderRadius: 4,
    backgroundImage: `url(${process.env.PUBLIC_URL + "/assets/images/logo.png"})`,
    backgroundPosition: "left center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    "&:focus-visible": {
      outline: "2px solid #00a3b4",
      outlineOffset: 2,
    },
  },
  content: {
    minWidth: 0,
    width: 0,
    height: "100vh",
    flexGrow: 1,
    overflow: "auto",
  },
  appBarSpacer: {
    minHeight: HEADER_HEIGHT,
    height: HEADER_HEIGHT,
    flexShrink: 0,
  },
  container: {
    minHeight: `calc(100vh - ${HEADER_HEIGHT}px)`,
    padding: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2),
    },
  },
}));

export default useSMQMainContainerStyles;
